export const EMPTY_TASK = {
  _id: "0",

  name: "",
  dueDate: "",
  dueTime: "",
  durationHours: "",
  tag: "",
  links: [],

  row: -1,
  col: -1,
  timeUnits: 1,

  isCompleted: {},
  mondayKey: [],
};
